<template>
    <v-container class="co-pagamento">
        <v-col class="pagamento">
            <v-card-text class="conteudo">
                <v-row no-gutters>
                    <div class="primary--text lighten-1 titulo">PAGAMENTO</div>
                </v-row>

                <v-radio-group v-model="metodoSelecionado" class="radio-group" hide-details>
                    <card-metodo-pagamento
                        v-for="metodo in metodosPagamentoAceitos"
                        :key="metodo.index"
                        :dados-cartao="dadosCartao"
                        :metodo="metodo"
                        :metodo-selecionado="metodoSelecionado"
                        class="mb-3"
                    ></card-metodo-pagamento>
                </v-radio-group>
            </v-card-text>

            <v-card-actions class="acoes d-block px-5 pt-5">

                <div v-if="mostrarInputCupom" class="d-flex wrapper-cupom pb-2 align-center">
                    <v-text-field
                        class="cupom-input"
                        v-model="cupom"
                        name="cupom-desconto"
                        placeholder="CUPOM DE DESCONTO"
                        outlined
                        height="35"
                        hide-details
                        :disabled="!metodoSelecionado || carregando"
                    />
                    <v-btn
                        color="green white--text"
                        class="cupom-btn"
                        depressed
                        type="button"
                        :disabled="ehDesabilitarAdicionarCupom"
                        :loading="carregando"
                        @click="lidarComCupom"
                    >
                        {{ !cupomAplicado ? 'Adicionar' : 'Remover' }}
                    </v-btn>
                </div>
                <v-divider/>

                <v-row class="py-3" no-gutters>
                    <v-btn
                        class="voltar"
                        depressed
                        @click="voltar"
                        :disabled="carregando"
                    >
                        Voltar
                    </v-btn>

                    <v-spacer/>

                    <v-img
                        :src="imagens.siteSeguro"
                        contain
                        height="40px"
                        max-width="100px"
                    />
                </v-row>
            </v-card-actions>
        </v-col>
    </v-container>
</template>

<script>

import SiteSeguro from '@/assets/icons/site-seguro.png'
import CardMetodoPagamento from './components/CardMetodoPagamento'
import {actionTypes, metodoPagamentoEnum} from '@/commons/constants'

export default {
    name: 'Pagamento',
    components: {CardMetodoPagamento},
    props: {
        dadosCartao: {
            type: Object,
        },
        ehCompraPlano: {
            type: Boolean,
            default: false
        },
        plano: {
            type: Object | undefined
        },
        valorTotalItens: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            imagens: {
                siteSeguro: SiteSeguro
            },
            metodoSelecionado: null,
            cupom: null,
            carregando: false,
            cupomAplicado: false,
            valorSemDesconto: null
        }
    },
    mounted() {
        this.valorSemDesconto = this.valorTotalItens
    },
    computed: {
        mostrarInputCupom() {
            return !!this.plano
        },
        metodosPagamentoAceitos() {
            return metodoPagamentoEnum
        },
        ehDesabilitarAdicionarCupom() {
            return !this.cupom || !this.metodoSelecionado
        }
    },
    watch: {
        'metodoSelecionado'() {
            this.$emit('atualizar-metodo-selecionado', this.metodoSelecionado)

            if (this.cupom === null) {
                this.$emit('remover-desconto-cupom', this.valorTotalItens)
            } else {
                this.$emit('remover-desconto-cupom', this.valorSemDesconto)
                this.cupomAplicado = false
                this.cupom = null
            }
        }
    },
    methods: {
        async ativarCupom() {
            if (!this.ehCompraPlano) {
                this.mostrarNotificacaoErro('Cupom disponível apenas para planos!')
                return
            }

            try {
                this.carregando = true
                const enumMetodoSelecionado = Object.keys(metodoPagamentoEnum)[this.metodoSelecionado.index]

                const cupomValidacao = await this.$store.dispatch(actionTypes.CUPOM.VALIDAR, {
                    codigo: this.cupom,
                    nomePlano: this.plano.nome,
                    ehCompraParcelada: false,
                    formaPagamento: enumMetodoSelecionado
                })

                this.$emit('aplicar-desconto-cupom', {
                    idCupom: cupomValidacao.idCupom,
                    valorDesconto: cupomValidacao.valorDesconto,
                    tipoDesconto: cupomValidacao.tipoDesconto
                })

                this.cupomAplicado = true
                this.mostrarNotificacaoSucesso('Cupom aplicado!')
            } finally {
                this.carregando = false
            }
        },
        fechar() {
            this.$emit('fechar')
        },
        lidarComCupom() {
            if (this.cupomAplicado) {
                this.removerCupom()
            } else {
                this.ativarCupom()
            }
        },
        removerCupom() {
            this.cupomAplicado = false
            this.cupom = null
            this.$emit('remover-desconto-cupom', this.valorSemDesconto)
        },
        voltar() {
            this.$emit('voltar')
        }
    }
}
</script>

<style lang="stylus">
.co-pagamento
    display flex
    max-height 550px

    .v-input__control
        width 100% !important

    .radio-group
        width 100%

    .pagamento
        background-color white
        align-items stretch
        justify-content space-between
        padding 0
        position relative

        .conteudo
            overflow-y auto
            height calc(100% - 141px)
            padding-bottom 0

        .acoes
            position absolute
            width 100%
            bottom 0
            background: #ffff

            .wrapper-cupom
                max-width 100%
                justify-content space-between
                gap 15px

                .cupom-input
                    .v-input__control
                        max-width 294px

                        .v-input__slot
                            min-height unset !important
                            width 75%
                            max-width 225px

                            .v-text-field__slot
                                input
                                    line-height normal

                                input:-webkit-autofill
                                    -webkit-background-clip: text

                .cupom-btn
                    flex unset
                    min-width unset
                    max-width 200px

    .certificado
        color #C7C7C7

    .voltar
        background: #eeeeee
        color #787878
        height 40px

@media (max-width: 765px)
    .co-pagamento
        .pagamento
            .acoes
                .wrapper-cupom
                    .cupom-input
                        .v-input__control
                            max-width 195px

                            .v-input__slot
                                width 100%

@media (max-width: 600px)
    .co-pagamento
        .pagamento
            .conteudo
                overflow-y unset
                height unset
                padding-bottom 137px

</style>
